module.exports = __webpack_public_path__ + "static/14_tawnia_sanford-70362e4960f5edf19bc2011a46e02405.png";